import * as THREE from "three";

let def = {
  previousAction: null,
  activeAction: null,
  currentIdle: null,
  tweens: [],
};

export function getVisemeAnimation(actions, value) {
  let res;
  switch (value) {
    case "k":
      res = "amazonPolly_phoneme_k_g_ng";
      break;
    case "a":
    case "@":
      res = "amazonPolly_phoneme_aa";
      break;
    case "sil":
      res = "defaultExpressions_Neutral";
      break;
    case "t":
    case "T":
      res = "amazonPolly_phoneme_d_t_n";
      break;
    case "s":
    case "S":
      res = "amazonPolly_phoneme_s_z";
      break;
    case "o":
    case "O":
      res = "amazonPolly_phoneme_ow";
      break;
    case "p":
      res = "amazonPolly_phoneme_p_b_m";
      break;
    case "E":
    case "e":
      res = "amazonPolly_phoneme_ey_eh_uh";
      break;
    case "u":
      res = "amazonPolly_phoneme_w_uw";
      break;
    case "i":
      res = "amazonPolly_phoneme_y_iy_ih_ix";
      break;
    case "r":
      res = "amazonPolly_phoneme_r";
      break;
    case "f":
      res = "amazonPolly_phoneme_f_v";
      break;
  }
  return actions[res];
}

export function animateLetter(actions, letter, playBackSpeed, callback) {
  const t = letter.time * (1 + (1 - (playBackSpeed || 1)));
  let time = t - window.timing;
  window.timing = t;

  console.log(" Start --->", letter.value, time);

  let action = getVisemeAnimation(actions, letter.value);
  action.loop = THREE.LoopOnce;
  action.clampWhenFinished = true;

  fadeToAction(action, time / 1000);

  setTimeout(() => {
    console.log(" END --->", letter.value);
    callback(null, letter.value);
  }, time);
}

export function playIdle(action, timescale = 0.65, cb) {
  if (!action) return;

  action.loop = THREE.LoopPingPong;
  action.timeScale = timescale;

  if (!def.currentIdle) {
    def.currentIdle = action;

    action.reset().play();
  } else if (def.currentIdle && def.currentIdle !== action) {
    def.currentIdle.fadeOut && def.currentIdle.fadeOut(0.5);
    action.reset().setEffectiveWeight(1).fadeIn(0.5).play();
    def.currentIdle = action;
    if (cb) setTimeout(cb, 500);
  }
}

export function fadeToAction(action, duration) {
  def.previousAction = def.activeAction;
  def.activeAction = action;

  if (def.previousAction && def.previousAction !== def.activeAction) {
    def.previousAction.fadeOut && def.previousAction.fadeOut(duration / 2);
  }

  def.activeAction
    .reset()
    .setDuration(duration)
    // .setEffectiveWeight(1)
    .fadeIn(duration / 2)
    .play();
}

// -----
function buildSpeechTweens(visemes) {
  var max = 0.5;
  var tweens = [];
  var lastTime = 0;
  for (var i = 0; i < visemes.length; i++) {
    var tween = {
      animations: [
        {
          name: visemes[i].value,
          from: 0,
          to: max,
          time: visemes[i].time,
          duration: visemes[i].duration,
        },
      ],
    };
    if (i > 0) {
      tween.animations.push({
        name: visemes[i - 1].value,
        from: max,
        to: 0,
        time: visemes[i].time,
        duration: visemes[i - 1].duration / 3,
      });
    }
    tweens.push(tween);
  }
  var tween = {
    animations: [
      {
        name: visemes[i - 1].value,
        from: max,
        to: 0,
        time: visemes[i - 1].time + visemes[i - 1].duration,
        duration: visemes[i - 1].duration / 2,
      },
    ],
  };
  tweens.push(tween);
  def.tweens.push({ current: -1, steps: tweens, type: "speech" });
}

function transition() {
  for (var i = def.tweens.length - 1; i >= 0; i--) {
    if (def.tweens[i].steps[def.tweens[i].current] != undefined) {
      transitionTween(i);
    } else {
      if (def.tweens[i].finished) {
        def.tweens.splice(i, 1);
      }
    }
  }
}

function transitionTween(idx) {
  if (def.tweens[idx].steps[def.tweens[idx].current] == undefined) {
    return;
  }
  var tween = def.tweens[idx].steps[def.tweens[idx].current];

  if (def.tweens[idx].baseTime == undefined) {
    def.tweens[idx].baseTime = performance.now();
  }

  if (tween.start == undefined) {
    tween.start = def.tweens[idx].baseTime + tween.animations[0].time;
    for (var i = 0; i < tween.animations.length; i++) {
      tween.animations[i].delta =
        (tween.animations[i].to - tween.animations[i].from) /
        tween.animations[i].duration;
    }
  }
  var pn = performance.now();
  var dur = pn - tween.start;
  for (var i = tween.animations.length - 1; i >= 0; i--) {
    var value = tween.animations[i].from + dur * tween.animations[i].delta;
    if (tween.animations[i].delta > 0) {
      if (value >= tween.animations[i].to) {
        value = tween.animations[i].to;
      } else if (value <= tween.animations[i].from) {
        value = tween.animations[i].from;
      }
    } else {
      if (value <= tween.animations[i].to) {
        value = tween.animations[i].to;
      } else if (value >= tween.animations[i].from) {
        value = tween.animations[i].from;
      }
    }
    // setSceneProperty(tween.animations[i].name, value);
  }

  if (dur > tween.animations[0].duration) {
    def.tweens[idx].current++;
    if (def.tweens[idx].current >= def.tweens[idx].steps.length) {
      def.tweens[idx].finished = true;
      if (def.tweens[idx].type == "speech") {
        console.log("DDDONE");
        // $scope.finishedTalking();
      }
    }
  }
  
}

export function run(visemes) {
  buildSpeechTweens(visemes);
}